module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.team_session != 1) ? _c('div', {
    staticClass: "intro-y box"
  }, [_c('div', {
    staticClass: "flex flex-col px-5 pt-5 pb-2"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v("Horas usadas en la semana del "), _c('b', [_vm._v(_vm._s(_vm.start_date))]), _vm._v(" al "), _c('b', [_vm._v(_vm._s(_vm.end_date))])]), _vm._v(" "), _c('div', {
    staticClass: "w-full h-4 bg-gray-400 rounded"
  }, [(_vm.percentage > 100) ? _c('div', {
    staticClass: "h-full rounded text-center text-xs text-white bg-theme-6",
    style: ({
      width: '100%'
    })
  }, [_vm._v(_vm._s(_vm.percentage) + "%")]) : _c('div', {
    staticClass: "h-full rounded text-center text-xs text-white bg-theme-1",
    style: ({
      width: _vm.percentage > 0 ? _vm.percentage + '%' : '0px'
    })
  }, [_vm._v(_vm._s(_vm.percentage) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between mx-5 pb-3"
  }, [_c('div', [_vm._v(_vm._s(_vm.hours_used) + " Horas Usadas")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.hours_account) + " Horas")])])]) : _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_c('div', {
    staticClass: "flex flex-col px-5 pb-2"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', [_c('div', {
      staticClass: "flex flex-col px-5 pt-5 pb-2"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('b', {
      class: [
        project.hours > 1 ?
        'text-theme-1' :
        '' ]
    }, [_vm._v(_vm._s(project.name))])]), _vm._v(" "), _c('div', {
      staticClass: "w-full h-4 bg-gray-400 rounded"
    }, [(project.percentage > 100) ? _c('div', {
      staticClass: "h-full rounded text-center text-xs text-white bg-theme-6",
      style: ({
        width: '100%'
      })
    }, [_vm._v(_vm._s(project.percentage) + "%")]) : _c('div', {
      staticClass: "h-full rounded text-center text-xs text-white bg-theme-1",
      style: ({
        width: project.percentage > 0 ? project.percentage + '%' : '0px'
      })
    }, [_vm._v(_vm._s(project.percentage) + "%")])])]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-between mx-5 pb-3"
    }, [_c('div', [_vm._v(_vm._s(project.hours_used) + " Horas Usadas")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(project.hours) + " Horas")])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-593827da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/task/HoursTasksComponent.vue
// module id = 442
// module chunks = 1